(function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }

      initCartUpsellArrows()
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const option = select.options[select.selectedIndex]
      const imgSrc = option.dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }

      const priceWrapper = select.closest('.cart-drawer-upsell-list-item').querySelector('[data-cart-drawer-upsell-price]')
      if (priceWrapper) {
        const price = option.dataset.price
        const compareAtPrice = option.dataset.compareAtPrice

        if (compareAtPrice) {
          priceWrapper.innerHTML =
            '<s class="cart-drawer-upsell-price__compare-at">' + compareAtPrice + '</s>' +
            '<strong class="cart-drawer-upsell-price__price">' + price + '</strong>'
        } else {
          priceWrapper.innerHTML =
            '<strong class="cart-drawer-upsell-price__price">' + price + '</strong>'
        }
      }
    }

    function initCartUpsellArrows() {
      const carousel = document.querySelector('.cart-drawer-upsell-carousel')
      if (!carousel) return

      const list = carousel.querySelector('.cart-drawer-upsell-list')
      const prevButton = carousel.querySelector('.cart-drawer-upsell-arrow--prev')
      const nextButton = carousel.querySelector('.cart-drawer-upsell-arrow--next')
      if (!list || !prevButton || !nextButton) return

      function getScrollAmount() {
        const item = list.querySelector('.cart-drawer-upsell-list-item')
        if (!item) return 200
        const style = window.getComputedStyle(list)
        const gap = parseInt(style.columnGap || style.gap || 10, 10)
        return item.getBoundingClientRect().width + gap
      }

      function updateArrowsState() {
        const maxScrollLeft = list.scrollWidth - list.clientWidth
        prevButton.disabled = list.scrollLeft <= 0
        nextButton.disabled = list.scrollLeft >= maxScrollLeft - 1
      }

      prevButton.addEventListener('click', function () {
        list.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' })
      })

      nextButton.addEventListener('click', function () {
        list.scrollBy({ left: getScrollAmount(), behavior: 'smooth' })
      })

      list.addEventListener('scroll', updateArrowsState)
      window.addEventListener('resize', updateArrowsState)
      updateArrowsState()
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();